import React from "react";
import { CircleToBlockLoading } from 'react-loadingg';

export default () => <CircleToBlockLoading />;
